export const productsPage = {
  seo: {
    title: "產品介紹｜來加綉綉紅豆餅人氣口味",
    description:
      "來加綉綉紅豆餅提供經典紅豆、奶油卡士達、芋泥、花生芝麻、起司鹹香與季節限定等多款手作紅豆餅口味，適合現烤享用、冷凍宅配與禮盒分享。",
  },
  hero: {
    tag: "產品介紹",
    title: "每一顆紅豆餅，都有自己的香氣與記憶點",
    subtitle:
      "從經典紅豆到創意口味，來加綉綉希望讓每一位顧客都能找到自己喜歡的那一顆。",
  },
  features: {
    sectionTitle: "來加綉綉的紅豆餅特色",
    items: [
      {
        title: "餅皮香氣",
        desc: "掌握火候與厚薄，讓餅皮有香氣，也能包住飽滿內餡。",
      },
      {
        title: "內餡比例",
        desc: "重視每一口的餡料存在感，讓顧客吃得到滿足。",
      },
      {
        title: "口味設計",
        desc: "保留傳統，也推出季節與創意風味，增加回訪期待。",
      },
      {
        title: "冷熱皆宜",
        desc: "現烤好吃，也適合規劃冷凍宅配、回烤享用與禮盒分享。",
      },
    ],
  },
  products: [
    {
      id: 1,
      name: "經典紅豆",
      shortDesc: "綿密紅豆香氣，是最熟悉也最耐吃的經典。",
      audience: "喜歡傳統口味、長輩、第一次購買者",
    },
    {
      id: 2,
      name: "奶油卡士達",
      shortDesc: "滑順奶香、甜度溫和，是大人小孩都容易喜歡的口味。",
      audience: "親子客群、學生、下午茶",
    },
    {
      id: 3,
      name: "芋泥香香",
      shortDesc: "厚實芋香與綿密口感，讓一顆紅豆餅更有飽足感。",
      audience: "芋泥控、甜點愛好者",
    },
    {
      id: 4,
      name: "花生芝麻",
      shortDesc: "堅果香氣濃厚，適合喜歡香氣層次的人。",
      audience: "熟齡客群、重口味甜點愛好者",
    },
    {
      id: 5,
      name: "起司鹹香",
      shortDesc: "鹹甜交錯，讓紅豆餅不只是一種甜點選擇。",
      audience: "想吃鹹口味、午茶點心、上班族",
    },
    {
      id: 6,
      name: "季節限定",
      shortDesc: "依季節與節慶推出限定風味，讓每次來都有新鮮感。",
      audience: "喜歡嘗鮮、社群分享、回訪客",
    },
  ],
  howToEnjoy: {
    sectionTitle: "現烤、回烤、分享，都有不同美味",
    items: [
      {
        title: "現場現烤",
        desc: "剛出爐時餅皮香氣最明顯，適合立即享用。",
      },
      {
        title: "冷凍宅配",
        desc: "依照保存與回烤建議，讓顧客在家也能吃到接近現烤的口感。",
      },
      {
        title: "禮盒分享",
        desc: "適合公司下午茶、節慶送禮、親友聚會與團購分享。",
      },
    ],
  },
  bottomCta: {
    title: "想訂購或詢問口味？",
    ctaPrimary: "加入 LINE 詢問",
    ctaSecondary: "前往禮盒宅配",
  },
};